<template>
  <!-- 2 row -->
  <v-layout row wrap v-if="type_richmenu === 1">
    <!-- <v-layout row wrap>
      <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1.5"
            min-height="140px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap>
      <v-col cols="4" v-for="(item, index) in list_menu" :key="index" class="d-flex child-flex pa-0">
        <v-img
          :src="item.picture"
          :lazy-src="item.picture"
          @click="sendrichmenu(item, index)"
          aspect-ratio="1"
        >
        </v-img>
      </v-col>
    </v-layout>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 2">
    <v-layout row wrap>
      <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1.5"
            min-height="100px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 3">
    <v-layout row wrap>
      <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="3"
            min-height="100px"
            @click="sendrichmenu(list_menu[0], 0)"
          >
          </v-img>
        </v-card>
      </v-flex>
      <v-flex v-if="index !== 0" v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="1"
            min-height="90px"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 4">
    <v-layout row wrap>
      <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            :src="list_menu[0].picture"
            :lazy-src="list_menu[0].picture"
            aspect-ratio="1"
            min-height="180px"
            @click="sendrichmenu(list_menu[0], 0)"
          >
          </v-img>
        </v-card>
      </v-flex>
      <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
        <v-card>
          <v-layout column>
            <v-flex v-if="index !== 0" v-for="(item, index) in list_menu" :key="index" xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
              <v-card>
                <v-img
                  cover
                  class="cursor"
                  min-height="100px"
                  :src="item.picture"
                  :lazy-src="item.picture"
                  aspect-ratio="1"
                  @click="sendrichmenu(item, index)"
                >
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 5">
    <v-layout row wrap>
      <v-flex v-for="(item, index) in list_menu" :key="index" xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
        <v-card>
          <v-img
            cover
            class="cursor"
            min-height="100px"
            :src="item.picture"
            :lazy-src="item.picture"
            aspect-ratio="3"
            @click="sendrichmenu(item, index)"
          >
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
  <v-layout row wrap justify-start v-else-if="type_richmenu === 6">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
      <v-card>
        <v-img
          class="cursor"
          :src="item.picture"
          :lazy-src="item.picture"
          min-height="240px"
          aspect-ratio="1.3"
          cover
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 7">
    <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          :lazy-src="list_menu[0].picture"
          aspect-ratio="1.5"
          min-height="240px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <!-- 1 row -->
  <v-layout row wrap justify-center v-else-if="type_richmenu === 8">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          :lazy-src="item.picture"
          aspect-ratio="1"
          min-height="90px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 9">
    <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          :lazy-src="list_menu[0].picture"
          aspect-ratio="1"
          min-height="90px"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[1].picture"
          :lazy-src="list_menu[1].picture"
          aspect-ratio="2"
          min-height="90px"
          @click="sendrichmenu(list_menu[1], 1)"
          >
        </v-img>
      </v-card>
    </v-flex>

  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 10">
    <v-flex xs8 md8 sm8 md8 lg8 xl8 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          :lazy-src="list_menu[0].picture"
          aspect-ratio="2"
          min-height="90px"
          @click="sendrichmenu(list_menu[0], 0)"
          >
        </v-img>
      </v-card>
    </v-flex>
    <v-flex xs4 md4 sm4 md4 lg4 xl4 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[1].picture"
          :lazy-src="list_menu[1].picture"
          aspect-ratio="1"
          min-height="90px"
          @click="sendrichmenu(list_menu[1], 1)"
          >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 11">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs6 md6 sm6 md6 lg6 xl6 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          :lazy-src="item.picture"
          aspect-ratio="1.5"
          min-height="90px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center v-else-if="type_richmenu === 12">
    <v-flex xs12 md12 sm12 md12 lg12 xl12 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="list_menu[0].picture"
          :lazy-src="list_menu[0].picture"
          aspect-ratio="3"
          height="70%"
          @click="sendrichmenu(list_menu[0], 0)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
    <v-layout row wrap justify-center v-else-if="type_richmenu === 13">
    <v-flex v-for="(item, index) in list_menu" :key="index" xs3 md3 sm3 md3 lg3 xl3 class="pa-0">
      <v-card>
        <v-img
          cover
          class="cursor"
          :src="item.picture"
          :lazy-src="item.picture"
          aspect-ratio="1.5"
          min-height="90px"
          @click="sendrichmenu(item, index)"
        >
        </v-img>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    Richmenudialog: false,
    inforrichmenu: {},
    type_richmenu: Number
  },
  data () {
    return {
      // type_richmenu: '12'
    }
  },
  created () {
    // console.log(this.inforrichmenu)
    // console.log(this.type_richmenu)
    this.list_menu = this.inforrichmenu
    // console.log(this.list_menu)
  },
  methods: {
    sendrichmenu (item, index) {
      // console.log(item)
      this.$emit('emitrichmenu', this.inforrichmenu[index])
    }
  },
  watch: {
    Richmenudialog () {
      if (this.Richmenudialog) {
        this.list_menu = this.inforrichmenu
      }
    }
  }
}
</script>

<style lang="css" scoped>
/* >>>.v-responsive .v-image {
  height: 100% !important;
} */
/* >>>.v-image__image--cover {
  background-size: contain !important;
} */
>>>.v-sheet.v-card {
  border-radius: 0px !important;
}
.cursor {
  cursor: pointer;
}
>>>.v-card__text {
  padding: 10px;
  width: 100%;
}
>>>.v-card {
  display: block;
  border-radius: 2px;
  min-width: 0;
  position: relative;
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.5,1) !important;
  box-shadow: none !important;
}
>>>.mx-auto .v-card .theme--dark {
  box-shadow: none !important;
}
</style>
